import MarkerComponent from "../components/marker.component";

export default class MarkerManager {
    constructor(mapComponent) {
        this.mapComponent = mapComponent;
        this.markers = [];
    }

    /**
     * @returns {Object} - Google Maps bounds
     */
    get boundsForMarkers() {
        const bounds = new window.google.maps.LatLngBounds();
        for (let i = 0; i < this.markers.length; i++) {
            bounds.extend(this.markers[i].getPosition());
        }

        return bounds;
    }

    clearMarkers() {
        this.markers.forEach(m => m.unbindMap());
        this.markers = [];
    }

    /**
     *
     * @param {Array<Object>} places - intially come from Global Search Event
     */
    createMarkersFromPlaces(places) {
        this.markers = places
            .filter(x => x.lat && x.lat !== 0 && x.lng && x.lng !== 0)
            .map(place => this.createMarker(place));
    }

    displayMarkers() {
        this.markers.forEach(m => m.bindMap(this.mapComponent.innerMap));
    }

    /**
     * @private
     */
    createMarker(place) {
        if (this.mapComponent.args.apartmentMode) {
            return this.createMarkerInApartmentMode(place);
        }

        return this.createMarkerRegularly(place);
    }

    /**
     * @private
     */
    createMarkerInApartmentMode(place) {
        const iconUrl = place.hasAvailableApartments
            ? this.mapComponent.args.markerApartmentAvailableUrl
            : this.mapComponent.args.markerApartmentNoAvailableUrl;

        const activeIconUrl = place.hasAvailableApartments
            ? this.mapComponent.args.markerApartmentAvailableActiveUrl
            : this.mapComponent.args.markerApartmentNoAvailableActiveUrl;

        return new MarkerComponent(place, iconUrl, activeIconUrl, true, this.mapComponent.mapClicked$);
    }

    /**
     * @private
     */
    createMarkerRegularly(place) {
        return new MarkerComponent(
            place,
            this.mapComponent.args.markerIconUrl,
            this.mapComponent.args.markerActiveIconUrl,
            false,
            this.mapComponent.mapClicked$,
        );
    }
}
